import { useContext, useEffect, useState } from 'react'
import { AssociationPage } from './AssociationPage'
import { ComparisonPage } from './ComparisonPage'
import { GenerationPage } from './GenerationPage'
import './index.less'
import { PaintingIntroPage } from './PaintingIntroPage'
import { SixLawsPage } from './SixLawsPage'
import {
  addCollectionPainting,
  getHistoryPaintingInfo,
  getImgsInfoByImgID,
  getPaintingIntro,
  getSixLawsInfo,
  savePic,
  SRC_URL
} from '@/server'
import {
  setAtrID,
  setColorBar,
  setDate,
  setGlobalTags,
  setGlobalTagTree,
  setHistoryGlobalTags,
  setLocalInfo,
  setLocalTagTree,
  setRecommend,
  setTime
} from '@/features/SetSixLawsInfo/setSixLawsInfo'
import {
  setAuthorName,
  setClass1,
  setClass2,
  setClass3,
  setDescription,
  setDynasty,
  setHeadHeight,
  setHeadWidth,
  setHorizontal,
  setMaterialType,
  setMediaType,
  setMuseum,
  setStyleType,
  setVertical,
  setWorkName
} from '@/features/SetPaintingIntroInfo/setPaintingIntroInfo'
import { useAppDispatch, useAppSelector } from '@/hooks'
import searchResult from '@/assets/mock/searchResult.json'
import MiniMapTag from '@/components/MiniMapTag'

import { setObjTags, setRects, setTechTags } from '@/features/SetSelectedRects/setSelectedRects'

import Rhyme from '@/components/Compare/Rhyme'
import Method from '@/components/Compare/Method'
import Form from '@/components/Compare/Form'
import Color from '@/components/Compare/Color'
import Position from '@/components/Compare/Position'
import Imitation from '@/components/Compare/Imitation'
import { FolderAddOutlined } from '@ant-design/icons'
import { message, Tooltip } from 'antd'

import { moon, sun } from '@/assets/images'
import { background, setAnalysisBackground } from '@/features/SetBackgroundColor/setBackgroundColor'
import { setToken } from '@/features/Login/login'
import { useNavigate } from 'react-router-dom'
import { setSelectedPage } from '@/features/SetAnalysisImageInfo/setAnalysisImageInfo'
import SealAnaysisPage from './SealAnalysisPage'
import { base64ToImageElement, imageToBase64 } from '@/components/SegmentHelpers/maskUtils'
import SegmentContext from '@/components/SegmentHelpers/hooks/createContext'
import SegmentPage from './SegmentPage'
import DisplayArea from './SegmentPage/DisplayArea'

// 分析页面(左侧)传移默写
export interface similarImgsInfoI {
  title: string
  similarity: number
  imageId: string
  workId: string
  author: string
  imgSrc: string
  dynasty: string
}
//分析页面
export function AnalysisPage() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const backgroundColor = useAppSelector((state) => state.backgroundColor.analysisBackground)
  //用户相关数据
  const token = useAppSelector((state) => state.login.token)
  const userId = useAppSelector((state) => state.login.userId)
  const workId = useAppSelector((state) => state.analysisImageInfo.workId)
  const imageId = useAppSelector((state) => state.analysisImageInfo.imageId)
  // 画作选择点击转到画作分析后获取Head信息
  const workname = useAppSelector((state) => state.paintingIntroInfo.workname)
  const mediatype = useAppSelector((state) => state.paintingIntroInfo.mediaType)
  const authorname = useAppSelector((state) => state.paintingIntroInfo.authorname)
  const materialType = useAppSelector((state) => state.paintingIntroInfo.materialType) //设色
  const horizontal = useAppSelector((state) => state.paintingIntroInfo.horizontal)
  const vertical = useAppSelector((state) => state.paintingIntroInfo.vertical)
  const _headWidth = useAppSelector((state) => state.paintingIntroInfo.width)
  const _headHeight = useAppSelector((state) => state.paintingIntroInfo.height)
  const dynasty = useAppSelector((state) => state.paintingIntroInfo.dynasty)
  const museum = useAppSelector((state) => state.paintingIntroInfo.instname)

  //各种标签tags
  const class1 = useAppSelector((state) => state.paintingIntroInfo.class1) //主题
  const class2 = useAppSelector((state) => state.paintingIntroInfo.class2) //类型
  const mediaType = useAppSelector((state) => state.paintingIntroInfo.mediaType) //材质
  const styleType = useAppSelector((state) => state.paintingIntroInfo.styleType) //形制
  const class3 = useAppSelector((state) => state.paintingIntroInfo.class3) //题材
  //六法信息
  const atrID = useAppSelector((state) => state.sixLawsInfo.atrID)
  const date = useAppSelector((state) => state.sixLawsInfo.date)
  const time = useAppSelector((state) => state.sixLawsInfo.time)
  const globalTagTree = useAppSelector((state) => state.sixLawsInfo.globalTagTree)
  const localTagTree = useAppSelector((state) => state.sixLawsInfo.localTagTree)
  const globalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)
  const _historyGlobalTags = useAppSelector((state) => state.sixLawsInfo.historyGlobalTags)
  const localInfo = useAppSelector((state) => state.sixLawsInfo.localInfo)
  const colorBar = useAppSelector((state) => state.sixLawsInfo.colorBar)
  const recommend = useAppSelector((state) => state.sixLawsInfo.recommend)
  // console.log(recommend, "analysisrecommend")
  //选择的页面: 0:画作简介 1:谢赫六法 2:画作对比 3:关联图谱 4:创作生成
  const selectedPage = useAppSelector((state) => state.analysisImageInfo.selectedPage)
  // 分析页面左侧head
  const _searchResultList = searchResult.result
  const [_currentHead, _setCurrentHead] = useState<string[]>([])
  //瓦片地图相关信息
  const [tilesPath, setTilesPath] = useState<string>('')
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)
  const [levelMax, setLevelMax] = useState<number>(0)
  const [levelMin, setLevelMin] = useState<number>(0)
  const {
    isSaving: [, setIsSaving],
    isLoading: [, setIsLoading],
    everythingMask: [, setEverythingMask],
    image: [, setImage]
  } = useContext(SegmentContext)!
  // 切换背景颜色的回调
  const handleChangeMode = function () {
    dispatch(
      setAnalysisBackground(backgroundColor === background.SUN ? background.MOON : background.SUN)
    )
  }
  // 保存图片至标注服务器
  const saveToSegment = (picPath: string) => {
    console.log('save')
    setIsLoading(true)
    setIsSaving(true)
    setImage(null)
    setEverythingMask([])
    base64ToImageElement(picPath)
      .then(async (image) => {
        const data = {
          img: imageToBase64(image),
          imgId: imageId
        }
        // console.log(data)
        await savePic(data)
          .then((_res) => {
            setIsSaving(false)
          })
          .catch((err) => {
            console.log(err)
          })
      })
      .catch((err) => {
        console.log(err)
      })
  }
  //点入分析界面时发请求
  useEffect(() => {
    getHistoryPaintingInfo(token, userId, imageId)
      .then((res) => {
        if (res.data.code === '10056') {
          //token失效
          window.confirm('登录已过期，请重新登录！')
          dispatch(setToken(''))
          navigate('/')
        } else {
          dispatch(setAtrID(res.data.atrID ?? ''))
          dispatch(setDate(res.data.date ?? ''))
          dispatch(setTime(res.data.time ?? ''))
          dispatch(
            setGlobalTagTree(
              res.data.globalTagTree ?? {
                主题: [],
                类型: [],
                材质: [],
                形制: [],
                意境: [],
                构图: [],
                题材: [],
                设色: []
              }
            )
          )
          dispatch(
            setLocalTagTree(
              res.data.localTagTree ?? {
                物象: [],
                技法: []
              }
            )
          )
          dispatch(
            setGlobalTags(
              res.data.globalTags ?? {
                意境: [],
                构图: []
              }
            )
          )
          dispatch(
            setHistoryGlobalTags(
              res.data.globalTags ?? {
                意境: [],
                构图: []
              }
            )
          )
          dispatch(setLocalInfo(res.data.localInfo ?? []))
          dispatch(setColorBar(res.data.colorBar ?? []))
          dispatch(setRecommend(res.data.recommend ?? []))
        }
      })
      .catch((_err) => {
        //该用户没有向后端提交过该幅画作相关的收藏信息
        getSixLawsInfo(token, imageId)
          .then((res) => {
            console.log('通过imageId从六法json获取的信息：', res.data)
            dispatch(setAtrID(res.data.atrID ?? ''))
            dispatch(setDate(res.data.date ?? ''))
            dispatch(setTime(res.data.time ?? ''))
            dispatch(
              setGlobalTagTree(
                res.data.globalTagTree ?? {
                  主题: [],
                  类型: [],
                  材质: [],
                  形制: [],
                  意境: [],
                  构图: [],
                  题材: [],
                  设色: []
                }
              )
            )
            dispatch(
              setLocalTagTree(
                res.data.localTagTree ?? {
                  物象: [],
                  技法: []
                }
              )
            )
            dispatch(
              setGlobalTags(
                res.data.globalTags ?? {
                  意境: [],
                  构图: []
                }
              )
            )
            dispatch(
              setHistoryGlobalTags(
                res.data.globalTags ?? {
                  意境: [],
                  构图: []
                }
              )
            )
            dispatch(setLocalInfo(res.data.localInfo ?? []))
            dispatch(setColorBar(res.data.colorBar ?? []))
            dispatch(setRecommend(res.data.recommend ?? []))
          })
          .catch((_err) => {
            dispatch(setAtrID(''))
            dispatch(setDate(''))
            dispatch(setTime(''))
            dispatch(
              setGlobalTagTree({
                主题: [],
                类型: [],
                材质: [],
                形制: [],
                意境: [],
                构图: [],
                题材: [],
                设色: []
              })
            )
            dispatch(
              setLocalTagTree({
                物象: [],
                技法: []
              })
            )
            dispatch(
              setGlobalTags({
                意境: [],
                构图: []
              })
            )
            dispatch(
              setHistoryGlobalTags({
                意境: [],
                构图: []
              })
            )
            dispatch(setLocalInfo([]))
            dispatch(setColorBar([]))
            dispatch(setRecommend([]))
          })
      })

    //根据imageId拿取瓦片地图相关信息
    getImgsInfoByImgID(token, { imageId: imageId })
      .then((res) => {
        if (res.data.code === '10056') {
          //token失效
          window.confirm('登录已过期，请重新登录！')
          dispatch(setToken(''))
          navigate('/')
        } else {
          saveToSegment(SRC_URL + res.data.content.encoding) //保存至标注系统后端
          setTilesPath(res.data.content.tilesPath ?? '')
          setWidth(res.data.content.width ?? 0)
          // console.log(res.data.content.width, "res.data.content.width")

          setHeight(res.data.content.height ?? 0)
          setLevelMax(res.data.content.tileslevelmax ? res.data.content.tileslevelmax - 1 : 0)
          setLevelMin(res.data.content.tileslevelmin ?? 0)
        }
      })
      .catch((_err) => {
        setTilesPath('')
        setWidth(0)
        setHeight(0)
        setLevelMax(0)
        setLevelMin(0)
      })
    //imageId更新后设置选中的rects为null
    console.log(1)
    dispatch(setRects([]))
    dispatch(setTechTags([]))
    dispatch(setObjTags([]))
  }, [dispatch, imageId, userId])

  //通过workid拿取简介信息等相关数据
  useEffect(() => {
    if (workId.length > 0) {
      getPaintingIntro(token, {
        workId: workId
      })
        .then((res) => {
          if (res.data.code === '10056') {
            //token失效
            window.confirm('登录已过期，请重新登录！')
            dispatch(setToken(''))
            navigate('/')
          } else {
            // console.log(res.data.content, "analysiscontent")
            dispatch(setClass1(res.data.content.class1 ?? ''))
            dispatch(setClass2(res.data.content.class2 ?? ''))
            dispatch(setMediaType(res.data.content.mediatype ?? ''))
            dispatch(setStyleType(res.data.content.styletype ?? ''))
            dispatch(setClass3(res.data.content.class3 ?? ''))
            dispatch(setMaterialType(res.data.content.materialtype ?? ''))
            dispatch(setDescription(res.data.content.description ?? '暂无简介'))
            dispatch(setWorkName(res.data.content.workname ?? ''))
            dispatch(setHorizontal(res.data.content.horizontal ?? ''))
            // console.log(res.data.content.horizontal, "res.data.content.horizontal")
            dispatch(setVertical(res.data.content.vertical ?? ''))
            // console.log(res.data.content.vertical, "res.data.content.vertical")
            dispatch(setHeadWidth(res.data.content.width ?? ''))
            dispatch(setHeadHeight(res.data.content.height ?? ''))
            dispatch(setDynasty(res.data.content.dynasty ?? ''))
            dispatch(setAuthorName(res.data.content.authorname ?? '佚名'))
            dispatch(setMuseum(res.data.content.instname ?? ''))
            // console.log(res.data.content.instname, "res.data.content.instname")
          }
        })
        .catch((_err) => {
          dispatch(setClass1(''))
          dispatch(setClass2(''))
          dispatch(setMediaType(''))
          dispatch(setStyleType(''))
          dispatch(setClass3(''))
          dispatch(setMaterialType(''))
          dispatch(setDescription('暂无简介'))
          dispatch(setWorkName(''))
          dispatch(setHorizontal(''))
          dispatch(setVertical(''))
          dispatch(setHeadWidth(''))
          dispatch(setHeadHeight(''))
          dispatch(setDynasty(''))
          dispatch(setAuthorName('佚名'))
          dispatch(setMuseum(''))
        })
    }
  }, [dispatch, workId])
  // 设置分析页面-画作对比（左侧）
  // const [selectedComparison, setSelectedComparison] = useState<null | number>(null)
  // const analysisSelectedComparison = useAppSelector((state) => state.analysisImageInfo.analysisSelectedComparison)
  const selectedComparison = useAppSelector((state) => state.analysisImageInfo.selectedComparison)
  const showType = useAppSelector((state) => state.compareInfo.showType)
  // 1、气韵生动-意境（左侧）
  const analysisGlobalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)
  const [currentRhymeTags, setCurrentRhymeTags] = useState<string[]>([])
  useEffect(() => {
    setCurrentRhymeTags(analysisGlobalTags.意境)
  }, [analysisGlobalTags.意境])
  // 2、骨法用笔
  const [currentMethodTags, setMethodCurrentTags] = useState<string[]>([])
  const methodLocalInfo = useAppSelector((state) => state.sixLawsInfo.localInfo)

  useEffect(() => {
    const newCurrentTags: string[] = []
    for (let i = 0; i < methodLocalInfo.length; i++) {
      const jifaTags = methodLocalInfo[i].tags.filter((item) => item.typeName === '技法')
      if (jifaTags.length > 0) {
        for (let j = 0; j < jifaTags[0].tags.length; j++) {
          if (!newCurrentTags.includes(jifaTags[0].tags[j])) {
            newCurrentTags.push(jifaTags[0].tags[j])
          }
        }
      }
    }
    setMethodCurrentTags(newCurrentTags)
  }, [methodLocalInfo])
  // 3、应物象形
  const [currentFormTags, setCurrentFormTags] = useState<string[]>([])
  const formLocalInfo = useAppSelector((state) => state.sixLawsInfo.localInfo)

  useEffect(() => {
    const newCurrentTags: string[] = []
    for (let i = 0; i < formLocalInfo.length; i++) {
      const wuxiangTags = formLocalInfo[i].tags.filter((item) => item.typeName === '物象')
      if (wuxiangTags.length > 0) {
        for (let j = 0; j < wuxiangTags[0].tags.length; j++) {
          if (!newCurrentTags.includes(wuxiangTags[0].tags[j])) {
            newCurrentTags.push(wuxiangTags[0].tags[j])
          }
        }
      }
    }
    setCurrentFormTags(newCurrentTags)
  }, [formLocalInfo])
  // 4、随类赋彩
  const fucaiData = useAppSelector((state) => state.sixLawsInfo.colorBar)
  // 5、经营位置
  const positionGlobalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)
  const positionGlobalTagTree = useAppSelector((state) => state.sixLawsInfo.globalTagTree)
  const [currentPositionTags, setCurrentPositionTags] = useState<string[]>([])
  const [currentPositionImgSrc, setCurrentPositionImgSrc] = useState<string>('')
  useEffect(() => {
    setCurrentPositionTags(positionGlobalTags.构图)
    if (positionGlobalTags.构图.length > 0) {
      const goutuInfo = positionGlobalTagTree.构图.filter(
        (item) => item.title === positionGlobalTags.构图[0]
      )
      if (goutuInfo.length > 0) {
        setCurrentPositionImgSrc(goutuInfo[0].imgSrc ?? '')
      }
    }
  }, [positionGlobalTagTree.构图, positionGlobalTags.构图])

  //6、传移模写
  const [similarImgsInfo, setSimilarImgsInfo] = useState<similarImgsInfoI[]>([])
  useEffect(() => {
    //recommend改变时发送请求，获取图像具体信息
    const dataArr: Promise<any>[] = []
    for (let i = 1; i < recommend.length; i++) {
      if (i >= 21) break
      dataArr.push(
        getImgsInfoByImgID(token, {
          imageId: recommend[i].uuid
        })
      )
    }
    const newSimilarImgsInfo: similarImgsInfoI[] = []
    const simImgs = Promise.all(dataArr).then((values) => {
      for (let i = 0; i < values.length; i++) {
        if (values[i].data.content !== null) {
          const currentSimilarImgInfo: similarImgsInfoI = {
            title: values[i].data.content.workname !== null ? values[i].data.content.workname : '',
            similarity: Number(recommend[i + 1].sim.toFixed(2)) * 100,
            imageId: recommend[i + 1].uuid,
            workId: values[i].data.content.workid,
            author:
              values[i].data.content.authorname !== null
                ? values[i].data.content.authorname
                : '佚名',
            imgSrc: values[i].data.content.encoding,
            dynasty: values[i].data.content.dynasty
          }
          newSimilarImgsInfo.push(currentSimilarImgInfo)
        }
      }
      setSimilarImgsInfo(newSimilarImgsInfo)
    })
    return () => {
      //异步问题的解决方式：组件卸载时强行让相似图像信息设为空值 不知道是否有更好的处理方法？
      simImgs.then(() => {
        setSimilarImgsInfo([])
      })
    }
  }, [recommend, token])

  useEffect(() => {
    console.log('horizontal', horizontal)
  }, [horizontal])

  return (
    <div className='analysis-container'>
      <div className='analysis-painting-show-area'>
        <div className='show-head'>
          <div className='head-name' style={{ display: workname ? 'block' : 'none' }}>
            {workname}
          </div>
          <div className='show-paintingInfo'>
            <div className='head-mediatype' style={{ display: mediatype ? 'block' : 'none' }}>
              {mediatype}&nbsp;
            </div>
            <div className='head-materialType' style={{ display: materialType ? 'block' : 'none' }}>
              {materialType}&nbsp;
            </div>
            <div className='head-horizontal' style={{ display: horizontal ? 'block' : 'none' }}>
              {horizontal}×
            </div>
            <div className='head-vertical' style={{ display: vertical ? 'block' : 'none' }}>
              {vertical}厘米&nbsp;
            </div>
            <div className='head-dynasty' style={{ display: dynasty ? 'block' : 'none' }}>
              {dynasty}
            </div>
            <div className='head-authorname' style={{ display: authorname ? 'block' : 'none' }}>
              /{authorname}&nbsp;
            </div>
            <div className='head-museum' style={{ display: museum ? 'block' : 'none' }}>
              {museum}&nbsp;
            </div>
            <div className='head-width' style={{ display: width ? 'block' : 'none' }}>
              {width}×
            </div>
            <div className='head-height' style={{ display: height ? 'block' : 'none' }}>
              {height}像素
            </div>
          </div>
          <Tooltip title='添加至收藏页'>
            <FolderAddOutlined
              className='head-addCollection'
              onClick={() => {
                addCollectionPainting(token, {
                  workid: workId,
                  class1: class1,
                  class2: class2,
                  class3: class3,
                  materialtype: materialType,
                  styletype: styleType,
                  mediatype: mediaType,
                  imageId: imageId, // 每个image对应一个六法
                  data: JSON.stringify({
                    atrID: atrID,
                    date: date,
                    time: time,
                    globalTagTree: globalTagTree,
                    localTagTree: localTagTree,
                    globalTags: globalTags,
                    localInfo: localInfo,
                    colorBar: colorBar,
                    recommend: recommend
                  }) // 这里放六法的json字符串
                })
                  .then((res) => {
                    if (res.data.code === '10056') {
                      //token失效
                      window.confirm('登录已过期，请重新登录！')
                      dispatch(setToken(''))
                      navigate('/')
                    } else {
                      console.log('上传结果：', res)
                      dispatch(setHistoryGlobalTags(globalTags)) //同步history和当前信息
                      message.success('添加至收藏界面成功！')
                    }
                  })
                  .catch((err) => {
                    console.log('添加至收藏界面失败！错误代码: ' + err.response.status)
                  })
              }}
            />
          </Tooltip>
          <div className='mode-btn' onClick={handleChangeMode}>
            <img src={backgroundColor === background.SUN ? sun : moon} alt='切换模式' />
          </div>
        </div>

        <div
          className='show-body'
          style={{
            display: selectedPage == 6 ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <DisplayArea />
        </div>
        <div className='show-body' style={{ display: selectedPage != 6 ? 'flex' : 'none' }}>
          <MiniMapTag
            tilesPath={tilesPath}
            width={width}
            height={height}
            levelMax={levelMax}
            levelMin={levelMin}
          />
        </div>

        {selectedPage === 2 && showType === 2 ? (
          <div className='analysis-rhyme'>
            {selectedComparison === 0 ? (
              <div className='rhyme-left'>
                <Rhyme currentTags={currentRhymeTags} />
              </div>
            ) : selectedComparison === 1 ? (
              <div className='method-left'>
                <Method currentTags={currentMethodTags} />
              </div>
            ) : selectedComparison === 2 ? (
              <div className='form-left'>
                <Form currentTags={currentFormTags} />
              </div>
            ) : selectedComparison === 3 ? (
              <div className='color-left'>
                <Color fucaiData={fucaiData} />
              </div>
            ) : selectedComparison === 4 ? (
              <div className='position-left'>
                <Position
                  currentTags={currentPositionTags}
                  currentImgSrc={currentPositionImgSrc}
                  class1={class1}
                />
              </div>
            ) : selectedComparison === 5 ? (
              <div className='imitation-left'>
                <Imitation similarImgsInfo={similarImgsInfo.slice(0, 3)} />
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className='analysis-dash'></div>
      <div className='analysis-painting-select-area'>
        <div className='analysis-head'>
          <div
            className={'analysis-head-item ' + (selectedPage === 0 ? 'item-selected' : '')}
            onClick={(_e) => dispatch(setSelectedPage(0))}
          >
            画作简介
          </div>
          <div
            className={'analysis-head-item ' + (selectedPage === 1 ? 'item-selected' : '')}
            onClick={(_e) => dispatch(setSelectedPage(1))}
          >
            谢赫六法
          </div>
          <div
            className={'analysis-head-item ' + (selectedPage === 2 ? 'item-selected' : '')}
            onClick={(_e) => {
              dispatch(setSelectedPage(2))
              // dispatch(setSelectedComparison(0))
            }}
          >
            画作对比
          </div>
          <div
            className={'analysis-head-item ' + (selectedPage === 3 ? 'item-selected' : '')}
            onClick={(_e) => dispatch(setSelectedPage(3))}
          >
            关联图谱
          </div>
          <div
            className={'analysis-head-item ' + (selectedPage === 4 ? 'item-selected' : '')}
            onClick={(_e) => dispatch(setSelectedPage(4))}
          >
            创作生成
          </div>
          <div
            className={'analysis-head-item ' + (selectedPage === 5 ? 'item-selected' : '')}
            onClick={(_e) => dispatch(setSelectedPage(5))}
          >
            印章分析
          </div>
          <div
            className={'analysis-head-item ' + (selectedPage === 6 ? 'item-selected' : '')}
            onClick={(_e) => dispatch(setSelectedPage(6))}
          >
            图像标注
          </div>
        </div>
        <div className='analysis-body'>
          {selectedPage === 0 ? (
            <PaintingIntroPage />
          ) : selectedPage === 1 ? (
            <SixLawsPage similarImgsInfo={similarImgsInfo} />
          ) : selectedPage === 2 ? (
            <ComparisonPage />
          ) : selectedPage === 3 ? (
            <AssociationPage name={authorname} />
          ) : selectedPage === 4 ? (
            <GenerationPage />
          ) : selectedPage === 5 ? (
            <SealAnaysisPage />
          ) : selectedPage === 6 ? (
            <SegmentPage />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}
